import styled from 'styled-components';
import Crown from '@paradigm/design-system/src/assets/Crown';
import {
  firstGold,
  secondSilver,
  thirdBronze,
  paradigmLightBlue,
  brilliantAzure,
} from '@paradigm/design-system/src/colors';

interface Props {
  isUserRow?: boolean;
  rank: number;
}

export default function RankBadge({ isUserRow, rank, ...rest }: Props) {
  return (
    <Container {...rest}>
      <CurvedCrown hidden={rank !== 1}>
        <Crown />
      </CurvedCrown>
      <Rank rank={rank} data-testid="rank-badge" isUserRow={isUserRow}>
        {rank}
      </Rank>
    </Container>
  );
}

const colorsRank = {
  1: firstGold,
  2: secondSilver,
  3: thirdBronze,
} as const;

const Rank = styled.div<{ rank: number; isUserRow?: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
  color: ${({ rank, isUserRow }) =>
    isFirstThree(rank)
      ? colorsRank[rank]
      : isUserRow === true
      ? paradigmLightBlue
      : '#ffffff'};

  height: 24px;
  width: 24px;
  border-radius: 5px;
  background-color: ${({ rank, isUserRow }) =>
    isFirstThree(rank)
      ? `${colorsRank[rank]}33`
      : isUserRow === true
      ? `${brilliantAzure}33`
      : 'transparent'};
`;

const isFirstThree = (rank: number): rank is keyof typeof colorsRank => {
  return rank <= 3;
};

const Container = styled.div`
  position: relative;
`;

const CurvedCrown = styled.div`
  position: absolute;
  top: -81%;
  left: -47%;
`;
